import { emit, events } from 'elc-service-bus';

export class ForgotPasswordLinkUseCase {
    public execute = () => {
        emit(events.FORGOT_PASSWORD_LINK_CLICK);
    };
}
